import MatterDropdown from "./MatterDropdown";

const NoCaseSelected = () => {

  return (
    <div className='flex flex-col justify-center items-center mt-36 gap-4'>
      <span className="text-2xl">Select a matter</span>
      <div className='w-1/5'>
        <MatterDropdown lightTrigger />
      </div>
    </div>
  );
};

export default NoCaseSelected;
